module.exports = __webpack_public_path__ + "static/img/bg-es.076d1c4e.png";